(function () {
  try {
    /* ======================= CONFIG ======================= */
    var HOOK = 'https://n8n.summitrxusa.com/webhook/session_tracking';
    var IPINFO_TOKEN = '40a9de113a6629';
    var HEARTBEAT_MS = 5000, CONFIRM_DELAY_MS = 1500, GEO_TIMEOUT_MS = 3000;
    var MAX_PAGES = 100, MAX_ACTIONS = 100;
    var DEFAULT_IDLE_MS = 60000 * 5; // 5 mins

    /* ======================= HELPERS ======================= */
    var LOG = (function () {
      try {
        return new URLSearchParams(location.search).get('srx_log') === '1';
      } catch (e) { return false; }
    })();

    function log() {
      if (!LOG || !window.console) return;
      try {
        var args = Array.prototype.slice.call(arguments);
        args.unshift('[srx]');
        console.log.apply(console, args);
      } catch (e) { }
    }

    function qp(n) {
      try {
        return new URLSearchParams(location.search).get(n) || '';
      } catch (e) { return ''; }
    }

    function uuid() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    }

    function nowISO() { return new Date().toISOString(); }

    function normPath(u) {
      try {
        var x = new URL(u, location.origin);
        var p = (x.pathname || '/').toLowerCase();
        return (p.length > 1 && p.endsWith('/')) ? p.slice(0, -1) : p;
      } catch (e) {
        var p2 = (location.pathname || '/').toLowerCase();
        return (p2.length > 1 && p2.endsWith('/')) ? p2.slice(0, -1) : p2;
      }
    }

    function ssGet(k, d) {
      try {
        var v = sessionStorage.getItem(k);
        return v ? JSON.parse(v) : d;
      } catch (e) { return d; }
    }

    function ssSet(k, v) {
      try {
        sessionStorage.setItem(k, JSON.stringify(v));
      } catch (e) { }
    }

    function seconds(t0) {
      return Math.max(0, Math.round((Date.now() - t0) / 1000));
    }

    function hasConsent() { return true; } // hook for CMP if needed

    function getCookie(n) {
      try {
        var m = document.cookie.split('; ').find(function (r) { return r.indexOf(n + '=') === 0; });
        return m ? decodeURIComponent(m.split('=')[1]) : '';
      } catch (e) { return ''; }
    }

    function setCookie(n, v, days) {
      try {
        var t = new Date();
        t.setTime(t.getTime() + days * 864e5);
        document.cookie = n + '=' + encodeURIComponent(v) +
          ';expires=' + t.toUTCString() + ';path=/;SameSite=Lax';
      } catch (e) { }
    }

    function secondsSince(ts) {
      try { return Math.max(0, Math.floor((Date.now() - Date.parse(ts)) / 1000)); }
      catch (e) { return null; }
    }

    function uidAgeDays(ts) {
      try { return Math.max(0, Math.floor((Date.now() - Date.parse(ts)) / (1000 * 60 * 60 * 24))); }
      catch (e) { return null; }
    }

    function toEasternISO(dateObj) {
      try {
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false
        });
        var parts = fmt.formatToParts(dateObj);
        var m = {};
        parts.forEach(function (p) {
          if (p.type !== 'literal') m[p.type] = p.value;
        });
        return m.year + '-' + m.month + '-' + m.day + 'T' +
          m.hour + ':' + m.minute + ':' + m.second;
      } catch (e) {
        return dateObj.toISOString();
      }
    }

    // Extract gclid from Google Ads cookie (_gcl_aw)
    function getCookieVal(name) {
      try {
        var m = document.cookie.split('; ').find(function (r) { return r.indexOf(name + '=') === 0; });
        return m ? decodeURIComponent(m.split('=')[1]) : '';
      } catch (e) { return ''; }
    }

    function gclidFromGclAw() {
      var v = getCookieVal('_gcl_aw');
      if (!v) return '';
      var parts = v.split('.');
      var cand = parts[parts.length - 1] || '';
      return /^[A-Za-z0-9_\-]{10,}$/.test(cand) ? cand : '';
    }

    // Extract gclid-ish from Google linker param (_gl)
    function gclidFromGlParam() {
      try {
        var gl = qp('_gl');
        if (!gl) return '';
        var m = gl.match(/[A-Za-z0-9_\-]{12,}/g);
        if (!m) return '';
        var pref = m.find(function (s) { return /^C/.test(s); });
        return (pref || m.sort(function (a, b) { return b.length - a.length; })[0] || '');
      } catch (e) { return ''; }
    }

    /* ======================= DURABLE UID ======================= */
    var UID_DAYS = 730; // 2 years
    var uid = getCookie('srx_uid');
    if (!uid) {
      uid = uuid();
      setCookie('srx_uid', uid, UID_DAYS);
    }
    var uid_first_ts = getCookie('srx_uid_first_ts');
    if (!uid_first_ts) {
      uid_first_ts = nowISO();
      setCookie('srx_uid_first_ts', uid_first_ts, UID_DAYS);
    }
    var uid_prev_last_ts = getCookie('srx_uid_last_ts') || null;
    var uid_last_ts = nowISO();
    setCookie('srx_uid_last_ts', uid_last_ts, UID_DAYS);

    /* ======================= SIMPLE TRANSPORT ======================= */
    function sendJSON(obj) {
      var bodyStr;
      try { bodyStr = JSON.stringify(obj); } catch (e) { bodyStr = '{}'; }
      try {
        return fetch(HOOK, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: bodyStr
        }).then(function () {
          log('fetch/no-cors fired');
          return true;
        }).catch(function (err) {
          log('fetch/no-cors failed', err);
          return false;
        });
      } catch (e) {
        log('fetch threw', e);
        return Promise.resolve(false);
      }
    }

    /* ======================= IDs & ATTRIBUTION ======================= */
    var sid = getCookie('srx_sid');
    if (!sid) {
      sid = uuid();
      setCookie('srx_sid', sid, 180);
    }
    var tab = sessionStorage.getItem('srx_tab') || uuid();
    sessionStorage.setItem('srx_tab', tab);

    // Record landing URL once per tab
    try {
      if (!sessionStorage.getItem('srx_landing_url')) {
        sessionStorage.setItem('srx_landing_url', location.href);
      }
    } catch (e) {}

    // Click IDs from all sources
    var qp_gclid = qp('gclid') || qp('gclsrc') || '';
    var qp_gbraid = qp('gbraid') || '';
    var qp_wbraid = qp('wbraid') || '';
    var qp_msclk  = qp('msclkid') || '';
    var qp_li     = qp('li_fat_id') || qp('li_click_id') || '';

    // From cookies / linker (older ad clicks)
    var ck_gclid = gclidFromGclAw() || gclidFromGlParam();

    // Click id present on THIS page URL
    var urlClick = (qp_gclid || qp_gbraid || qp_wbraid || qp_msclk || qp_li).trim();
    // Click id only from cookies (no param in URL)
    var cookieClick = (!urlClick && ck_gclid) ? ck_gclid : '';

    var clickIdValue = urlClick || cookieClick || '';

    if (clickIdValue) {
      // Store main click id
      sessionStorage.setItem('srx_click_id', clickIdValue);

      // Source network
      var src =
        (qp_gclid || qp_gbraid || qp_wbraid || ck_gclid) ? 'google' :
        (qp_msclk ? 'microsoft' :
        (qp_li ? 'linkedin' : 'unknown'));

      sessionStorage.setItem('srx_click_src', src);

      // Where did we get this id from?
      var origin = urlClick ? 'url' : (cookieClick ? 'cookie' : 'unknown');
      sessionStorage.setItem('srx_click_origin', origin);

      // For the first page in this tab, remember landing click id
      if (!sessionStorage.getItem('srx_landing_click_id')) {
        sessionStorage.setItem('srx_landing_click_id', clickIdValue);
      }

      log('click_id captured:', clickIdValue, 'source:', src, 'origin:', origin);
    }

    // Channel attribution for this tab
    var channel =
      (qp_gclid || qp_gbraid || qp_wbraid || ck_gclid) ? 'google' :
      (qp_msclk ? 'microsoft' :
      (qp_li ? 'linkedin' :
        (sessionStorage.getItem('srx_channel') || null)));
    if (channel) sessionStorage.setItem('srx_channel', channel);

    // First-touch UTM for this tab (still stored, not all sent)
    if (!sessionStorage.getItem('srx_landing_utm')) {
      var utm0 = {
        utm_source: qp('utm_source') || null,
        utm_medium: qp('utm_medium') || null,
        utm_campaign: qp('utm_campaign') || null,
        utm_term: qp('utm_term') || null
      };
      sessionStorage.setItem('srx_landing_utm', JSON.stringify(utm0));
    }

    // Landing referrer for this tab (external only)
    var landingRef = sessionStorage.getItem('srx_landing_referrer') || null;
    if (!landingRef) {
      var ref = document.referrer || '';
      try {
        if (ref && new URL(ref).origin === location.origin) {
          ref = '';
        }
      } catch (e) { }
      landingRef = ref || null;
      try { sessionStorage.setItem('srx_landing_referrer', landingRef || ''); } catch (e) { }
    }

    // Simple confirm key (for SPA transitions)
    (function cleanupConfirms() {
      try {
        var now = Date.now(), rm = [];
        for (var i = 0; i < localStorage.length; i++) {
          var k = localStorage.key(i);
          if (k && k.indexOf('srx_confirm_') === 0) {
            try {
              var v = JSON.parse(localStorage.getItem(k) || 'null');
              if (!v || !v.ts || (now - v.ts > 10000)) rm.push(k);
            } catch (e) { rm.push(k); }
          }
        }
        rm.forEach(function (k) { localStorage.removeItem(k); });
      } catch (e) { }
    })();
    var CONFIRM_KEY = 'srx_confirm_' + tab;
    try {
      localStorage.setItem(CONFIRM_KEY, JSON.stringify({ ts: Date.now(), path: location.pathname }));
    } catch (e) { }

    /* ======================= STATE ======================= */
    var STATE_KEY = 'srx_state_' + tab;
    var state = ssGet(STATE_KEY, null);
    if (!state || state.sent) {
      state = { pages: [], actions: [], started: Date.now(), last: Date.now(), sent: false };
      ssSet(STATE_KEY, state);
      log('state:new');
    } else {
      log('state:loaded', state.pages.length, 'pages');
    }
    function save() { ssSet(STATE_KEY, state); }

    /* ======================= GEO (BASIC ONLY) ======================= */
    function getGeo() {
      var c = ssGet('srx_geo', null);
      if (c) return Promise.resolve(c);
      return new Promise(function (resolve) {
        var done = false;
        function finish(o) {
          if (done) return;
          done = true;
          ssSet('srx_geo', o || {});
          resolve(o || {});
        }
        var t = setTimeout(function () { finish({}); }, GEO_TIMEOUT_MS);
        fetch('https://api.ipinfo.io/lite/me?token=' + encodeURIComponent(IPINFO_TOKEN), { credentials: 'omit' })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            clearTimeout(t);
            var base = {
              ip: j.ip || null,
              geo_city: j.city || null,
              geo_region: j.region || null,
              geo_country: j.country || null,
              geo_postal: j.postal || null
            };
            finish(base);
          })
          .catch(function () {
            clearTimeout(t);
            finish({});
          });
      });
    }

    /* ======================= SESSION STATS (CROSS-SESSION) ======================= */
    function getStats() {
      try {
        var v = getCookie('srx_stats');
        return v ? JSON.parse(v) : null;
      } catch (e) { return null; }
    }

    function saveStats(o) {
      try {
        setCookie('srx_stats', JSON.stringify(o), UID_DAYS);
      } catch (e) { }
    }

    function extractSearchTerm(ref) {
      if (!ref) return null;
      try {
        var u = new URL(ref);
        var host = u.hostname || '';
        var qs = u.searchParams;
        var term = null;
        if (/google\./.test(host) ||
          /bing\.com$/.test(host) ||
          /search\.yahoo\.com$/.test(host) ||
          /duckduckgo\.com$/.test(host)) {
          term = qs.get('q') || qs.get('p') || qs.get('query') || null;
        }
        if (term) {
          term = term.replace(/\+/g, ' ').trim();
          if (term.length > 200) term = term.slice(0, 200);
        }
        return term || null;
      } catch (e) {
        return null;
      }
    }

    /* ======================= TIMING ======================= */
    var pagePath = normPath(location.href),
      pageStart = Date.now(),
      committing = false;

    function commitPage() {
      if (committing) return;
      committing = true;
      var pathSnapshot = pagePath,
        startSnapshot = pageStart,
        dt = seconds(startSnapshot);
      if (dt >= 1 && state.pages.length < MAX_PAGES) {
        var last = state.pages[state.pages.length - 1];
        if (last && last.p === pathSnapshot) last.t += dt;
        else state.pages.push({ p: pathSnapshot, t: dt });
        state.last = Date.now();
        save();
        log('commit', pathSnapshot, dt + 's');
      }
      pageStart = Date.now();
      committing = false;
    }

    var hb = setInterval(function () {
      if (document.visibilityState === 'visible') commitPage();
    }, HEARTBEAT_MS);

    // SPA navigation support
    (function () {
      try {
        var PS = history.pushState,
          RS = history.replaceState;
        function changed() {
          commitPage();
          pagePath = normPath(location.href);
          pageStart = Date.now();
          state.last = Date.now();
          save();
        }
        history.pushState = function () {
          var r = PS.apply(this, arguments);
          setTimeout(changed, 0);
          return r;
        };
        history.replaceState = function () {
          var r = RS.apply(this, arguments);
          setTimeout(changed, 0);
          return r;
        };
        window.addEventListener('popstate', changed);
      } catch (e) { }
    })();

    /* ======================= ACTIONS ======================= */
    document.addEventListener('click', function (e) {
      try {
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a) return;
        var href = (a.getAttribute('href') || '').trim();
        if (!href) return;
        var kind = href.indexOf('mailto:') === 0 ? 'mailto' :
          (href.indexOf('tel:') === 0 ? 'tel' : '');
        if (!kind) return;
        if (state.actions.length < MAX_ACTIONS) {
          state.actions.push({ a: kind, href: href, t: seconds(state.started) });
          save();
          log('action', kind, href);
        }
      } catch (ex) { }
    }, true);

    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (!f || !(f instanceof HTMLFormElement)) return;
        var id = f.getAttribute('id') || null,
          nm = f.getAttribute('name') || null,
          act = f.getAttribute('action') || null;

        // Track on-site search queries
        if (state.actions.length < MAX_ACTIONS && act && act.indexOf('/search') !== -1) {
          var qInput = f.querySelector('input[name="q"], input[type="search"]');
          var qVal = qInput && qInput.value ? qInput.value.trim() : null;
          if (qVal) {
            state.actions.push({
              a: 'onsite_search',
              query: qVal,
              t: seconds(state.started)
            });
          }
        }

        // Generic form_submit
        if (state.actions.length < MAX_ACTIONS) {
          state.actions.push({
            a: 'form_submit',
            id: id,
            name: nm,
            action: act,
            t: seconds(state.started)
          });
          save();
          log('action', 'form_submit', id || nm || act || '');
        }
      } catch (ex) { }
    }, true);

    /* ======================= FLUSH ======================= */
    var flushing = false;

    function basePayload() {
      var tz = null;
      try {
        tz = (Intl && Intl.DateTimeFormat)
          ? Intl.DateTimeFormat().resolvedOptions().timeZone
          : null;
      } catch (e) { }

      var utm = {};
      try {
        utm = JSON.parse(sessionStorage.getItem('srx_landing_utm') || '{}');
      } catch (e) { }

      var deviceType = /Mobile|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile/i
        .test(navigator.userAgent) ? 'mobile' : 'desktop';

      var landingPath = (state.pages && state.pages[0])
        ? state.pages[0].p
        : normPath(location.href);
      var exitPath = (state.pages && state.pages.length)
        ? state.pages[state.pages.length - 1].p
        : landingPath;

      var storedClickId = sessionStorage.getItem('srx_click_id') || null;
      var clickIdToSend = storedClickId || (gclidFromGclAw() || gclidFromGlParam()) || null;
      var clickSrc = sessionStorage.getItem('srx_click_src') || null;

      var landingUrl = sessionStorage.getItem('srx_landing_url') || location.href;
      var landingClickId = sessionStorage.getItem('srx_landing_click_id') || null;
      var clickOrigin = sessionStorage.getItem('srx_click_origin') || (clickIdToSend ? 'unknown' : null);

      var now = new Date();

      var base = {
        event_type: 'session_summary',
        ts_utc: now.toISOString(),
        ts_eastern: toEasternISO(now),
        ts_unix: Date.now(),
        time_zone: tz,

        // Navigation
        landing_page_url: landingUrl,
        landing_page_path: landingPath,
        exit_page_path: exitPath,
        landing_referrer: landingRef || document.referrer || null,
        search_term: extractSearchTerm(landingRef || null),

        // IDs
        sid: sid,
        uid: uid,
        uid_first_ts: uid_first_ts,
        uid_last_ts: uid_last_ts,
        uid_prev_last_ts: uid_prev_last_ts,
        uid_return_gap_sec: uid_prev_last_ts ? secondsSince(uid_prev_last_ts) : null,
        uid_age_days: uidAgeDays(uid_first_ts),

        click_id: clickIdToSend,
        click_id_source: clickSrc,
        click_id_origin: clickOrigin,
        landing_click_id: landingClickId,
        utm_term: utm.utm_term || null,

        ua: navigator.userAgent,
        device_type: deviceType,
        session_key: sid + '_' + tab
      };

                  // === Header-compatible aliases (KEEP existing fields too) ===
        base.TS_UNIX = base.ts_unix;
        base.Timezone = base.time_zone;

        base.Landing_Page_URL_Path = base.landing_page_path;
        base.Last_Page_Path = base.exit_page_path;
        base.Landing_Referrer = base.landing_referrer;

        base.Ad_Click_ID = base.click_id;
        base.Channel = base.click_id_source;

        base.UserAgent = base.ua;

        base["Device_Type"] = base.device_type;
        base["UTM_Term"] = base.utm_term;

        base["I.P."] = base.ip || null;
        base["City"] = base.geo_city || null;

        // Your header says "State/ Country" (single column). Send a combined value:
        base["State/ Country"] =
          (base.geo_region && base.geo_country)
            ? (base.geo_region + ", " + base.geo_country)
            : (base.geo_region || base.geo_country || null);

        base["sID"] = base.sid;
        base["Session Key"] = base.session_key;

      return base;
    }

    function flush(reason) {
      if (!hasConsent()) return;
      if (state.sent || flushing) return;
      flushing = true;

      commitPage();

      var payload = basePayload();
      var durationSec = seconds(state.started);
      payload.session_started_unix = state.started;
      payload.session_duration_sec = durationSec;
      payload.session_pages_json = JSON.stringify(state.pages || []);
      payload.session_actions_json = JSON.stringify(state.actions || []);
      payload.reason = reason || 'close';

      // Debug info
      try {
        payload.debug = payload.debug || {};
        payload.debug.heartbeat_ms = HEARTBEAT_MS;
        var p = parseInt(qp('srx_idle_ms'), 10);
        payload.debug.idle_ms =
          (!isNaN(p) && p >= 3000 && p <= 3600000) ? p : DEFAULT_IDLE_MS;
      } catch (e) { }

      // === Session timing fields (Eastern) ===
      var startDate = new Date(state.started);
      var endDate = new Date(state.started + durationSec * 1000);

      payload.latest_session_start_time_utc = startDate.toISOString();
      payload.latest_session_end_time_utc = endDate.toISOString();
      payload.latest_session_start_time_est = toEasternISO(startDate);
      payload.latest_session_end_time_est = toEasternISO(endDate);

      // === Cross-session stats with 15-minute rule ===
      var stats = getStats() || {};
      var priorKeys = stats.session_keys || [];
      var priorSids = stats.sids || [];
      var priorFirstEnd = stats.first_session_end_ts || null;
      var priorTotal = stats.total_sessions || 0;
      var lastEndTs = stats.last_session_end_ts || null;

      payload.total_sessions = priorTotal || 0;
      payload.first_session_end_time_utc = priorFirstEnd || null;
      payload.first_session_end_time_est = priorFirstEnd ? toEasternISO(new Date(priorFirstEnd)) : null;
      payload.previous_session_keys_json = JSON.stringify(priorKeys);
      payload.previous_sids_json = JSON.stringify(priorSids);

      // Update stats for NEXT time
      var thisStartMs = state.started;
      var thisEndISO = endDate.toISOString();
      var fifteenMs = 15 * 60 * 1000;
      var isNewSession = true;

      if (lastEndTs) {
        try {
          var lastEndMs = Date.parse(lastEndTs);
          if (!isNaN(lastEndMs) && (thisStartMs - lastEndMs) <= fifteenMs) {
            isNewSession = false; // same session cluster
          }
        } catch (e) { }
      }

      var newTotal = priorTotal;
      var newKeys = priorKeys.slice();
      var newSids = priorSids.slice();
      var thisSessionKey = payload.session_key;

      if (isNewSession) {
        newTotal = (priorTotal || 0) + 1;
        newKeys.push(thisSessionKey);
        newSids.push(sid);
        if (!priorFirstEnd) {
          priorFirstEnd = thisEndISO;
        }
      }

      stats.total_sessions = newTotal;
      stats.first_session_end_ts = priorFirstEnd || thisEndISO;
      stats.last_session_end_ts = thisEndISO;
      stats.session_keys = newKeys;
      stats.sids = newSids;
      saveStats(stats);

      // overwrite totals with updated number (so current row shows current total)
      payload.total_sessions = newTotal;
      payload.first_session_end_time_utc = stats.first_session_end_ts;
      payload.first_session_end_time_est = toEasternISO(new Date(stats.first_session_end_ts));

      function finalize() {
        var geo = ssGet('srx_geo', null);
        if (geo) Object.assign(payload, geo);
        sendJSON(payload);
        state.sent = true;
        save();
        try { sessionStorage.removeItem(STATE_KEY); } catch (e) { }
        log('flushed', reason, payload);
      }

      if (!ssGet('srx_geo', null)) getGeo().finally(finalize);
      else finalize();
    }

    function scheduleCloseFlush(evReason) {
      var myHideTs = Date.now();
      try { clearInterval(hb); } catch (e) { }
      try { commitPage(); } catch (e) { }
      setTimeout(function () {
        try {
          var c = null;
          try { c = JSON.parse(localStorage.getItem(CONFIRM_KEY) || 'null'); } catch (e) { }
          if (c && c.ts && c.ts >= myHideTs) {
            log('close flush suppressed (confirm seen) but time committed');
            return;
          }
          flush(evReason);
        } catch (e) { }
      }, CONFIRM_DELAY_MS);
    }

    // Terminal events
    window.addEventListener('pagehide', function () { scheduleCloseFlush('pagehide'); });
    window.addEventListener('beforeunload', function () { scheduleCloseFlush('beforeunload'); }, { capture: true });

    // Idle flush
    (function () {
      try {
        var param = parseInt(qp('srx_idle_ms'), 10);
        var idleMs = (!isNaN(param) && param >= 3000 && param <= 3600000) ? param : DEFAULT_IDLE_MS;
        var idleTimer = null;
        function arm() {
          if (idleTimer) clearTimeout(idleTimer);
          idleTimer = setTimeout(function () { flush('idle'); }, idleMs);
        }
        ['click', 'keydown', 'scroll', 'mousemove', 'touchstart', 'focus'].forEach(function (ev) {
          window.addEventListener(ev, arm, { passive: true });
        });
        arm();
      } catch (e) { }
    })();

    // Manual helpers (unchanged interface)
    window.srx_flush = function () { try { flush('manual'); } catch (e) { } };

    window.srx_health = function () {
      try {
        var stKey = 'srx_state_' + (sessionStorage.getItem('srx_tab') || '(no-tab)');
        var stateH = null;
        try { stateH = JSON.parse(sessionStorage.getItem(stKey) || 'null'); } catch (e) { }
        var info = {
          version: 'srx-2025-12-03-est-landing',
          has_flush: typeof window.srx_flush === 'function',
          tab: sessionStorage.getItem('srx_tab'),
          sid: (document.cookie.match(/(?:^|;\s*)srx_sid=([^;]+)/) || [])[1] || null,
          click_id: sessionStorage.getItem('srx_click_id'),
          click_id_source: sessionStorage.getItem('srx_click_src'),
          click_id_origin: sessionStorage.getItem('srx_click_origin'),
          channel: sessionStorage.getItem('srx_channel'),
          utm: (function () { try { return JSON.parse(sessionStorage.getItem('srx_landing_utm') || '{}'); } catch (e) { return {}; } })(),
          landing_referrer: landingRef || null,
          state_key: stKey,
          pages_len: stateH && stateH.pages ? stateH.pages.length : 0,
          actions_len: stateH && stateH.actions ? stateH.actions.length : 0,
          started: stateH ? stateH.started : null,
          last: stateH ? stateH.last : null,
          sent: stateH ? stateH.sent : null
        };
        console.log('[srx][health]', info);
        return info;
      } catch (e) {
        console.log('[srx][health] error', e);
        return null;
      }
    };

    window.srx_ping = function () {
      try {
        var payload = { event_type: 'srx_ping', ts: new Date().toISOString(), ua: navigator.userAgent };
        sendJSON(payload);
        console.log('[srx][ping] sent');
      } catch (e) {
        console.log('[srx][ping] threw', e);
      }
    };

  } catch (e) {
    if (window.console) console.error('[srx] fatal', e);
  }
})();
